import i18n from '../localization';
import { EDrainageTrenchType, EWheelbaseCheck } from '../shared/enum';
import { IResult } from '../shared/iResult';
import { dialog } from '../shared/util';
import { redux } from '../store';
import { setAlert } from '../store/alert/alertSlice';

const validationAlertOutput = (output: IResult) => {
    const project = redux.getState().project;
    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    let errors: string[] = [];

    const checkAndAddError = (condition: boolean, errorKey: string) => {
        if (condition) errors.push(errorKey);
    };

    checkAndAddError(!output.phaseTwoOutputCalculation.fsTablesWithResults.evaluationOfSlopeStabilityPostIntervention.isSlopeStable, i18n.t('stableSlopeError'));
    checkAndAddError(
        !output.phaseTwoOutputCalculation.drainingCapacity.primaryDrainageTrench.isOkDrainingCapacity ||
            (hasSecondaryDrainageTrench && !output.phaseTwoOutputCalculation.drainingCapacity.secondaryDrainageTrench!.isOkDrainingCapacity),
        i18n.t('drainingCapacityError'),
    );
    checkAndAddError(
        hasSecondaryDrainageTrench &&
            project.data?.drainageTrenches![EDrainageTrenchType.PrimaryDrainageTrench].product?.hasPipe! &&
            !output.phaseTwoOutputCalculation.drainingDrainPipes.isOkMaximumNumberOfSecondaryDrainingLines,
        i18n.t('maximumNumberOfSecondaryDrainingLinesError'),
    );
    checkAndAddError(
        !output.phaseTwoOutputCalculation.drainingDrainPipes.primaryDrainageTrench.isOkRatioWithDrainageCapacityQtQdren ||
            (hasSecondaryDrainageTrench && !output.phaseTwoOutputCalculation.drainingDrainPipes.secondaryDrainageTrench!.isOkRatioWithDrainageCapacityQtQdren),
        i18n.t('ratioWithDrainageCapacityQtQdrenError'),
    );

    let isWheelbaseError =
        output.phaseTwoOutputCalculation.wheelbase.primaryDrainageTrench.check == EWheelbaseCheck.NotOk ||
        (hasSecondaryDrainageTrench && output.phaseTwoOutputCalculation.wheelbase.secondaryDrainageTrench.check == EWheelbaseCheck.NotOk);

    checkAndAddError(isWheelbaseError, i18n.t('wheelbaseError'));
    if (isWheelbaseError) {
        dialog('warning', i18n.t('wheelbaseErrorInfo'));
    }

    checkAndAddError(
        !output.phaseTwoOutputCalculation.calculationOfPressuresInTheSoil.longTermDrain.isPrimaryDrainageTrenchOk ||
            !output.phaseTwoOutputCalculation.calculationOfPressuresInTheSoil.shortTermDrain.isPrimaryDrainageTrenchOk ||
            (hasSecondaryDrainageTrench && !output.phaseTwoOutputCalculation.calculationOfPressuresInTheSoil.longTermDrain.isSecondaryDrainageTrenchOk) ||
            (hasSecondaryDrainageTrench && !output.phaseTwoOutputCalculation.calculationOfPressuresInTheSoil.shortTermDrain.isSecondaryDrainageTrenchOk),
        i18n.t('pressuresInTheSoilError'),
    );

    if (errors.length > 0) {
        let errorMessage = errors.join(', ');
        redux.dispatch(setAlert({ title: errorMessage }));
    }
};

export default validationAlertOutput;
